import React from 'react';
import { IKeywordList, IPaginationData } from '../../Screens/Company/Company.types';
import {
	RightTabContainer,
	RightTabItem,
} from '../../Screens/SingleReport/SingleReport.styled';
import { TableData } from '../../Screens/Company/Company.styled';
import { FaExpandAlt } from 'react-icons/fa';
import { Popover } from '..'

export const KEYWORDS_PLACEHOLDER =
	'Keyword insights are being improved and will be shown later.';

const KeywordTable = (props: { navigateToCompare: () => void, keywordList: IKeywordList[], keywordPagination: IPaginationData, limit?: number }) => (
	<React.Fragment>
		<RightTabContainer className="pt-2 mx-2 justify-content-between">
			<RightTabItem onClick={() => { }} selected={true}>
				Top Keywords
				<Popover
					className='ps-1'
					popoverTrigger='hover'
					popoverPlacement='auto'
					popoverTextHeader="**Top Keywords**"
					popoverTextBody={`Shows all keywords from the company within the selected timeframe (default: 5 years).`}
				/>
			</RightTabItem>
			<div
				className="d-flex align-items-center"
				onClick={props.navigateToCompare}
				style={{ cursor: 'pointer' }}>
				<h5 className="fs-10 fw-400 mb-0 me-1">View More </h5>
				<div className="bg-lightgrey rounded px-1">
					<FaExpandAlt className="fs-10" />
				</div>
			</div>
		</RightTabContainer>
			<div className="table-container">
				<div className="table-scrollable">
					<div className="text-center p-4 fs-10 fw-500">
						<TableData>{KEYWORDS_PLACEHOLDER}</TableData>
					</div>
				</div>
			</div>
		</React.Fragment>
);

export default KeywordTable;
